import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "mb-3 row" }
const _hoisted_2 = { class: "col-sm-10" }
const _hoisted_3 = { class: "mb-3 row" }
const _hoisted_4 = { class: "col-sm-10" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mb-3 row" }
const _hoisted_7 = { class: "col-sm-10" }
const _hoisted_8 = { class: "mb-3 row" }
const _hoisted_9 = { class: "col-sm-10" }
const _hoisted_10 = {
  class: "col-form-label",
  "aria-label": "Current Time",
  id: "currentTime"
}
const _hoisted_11 = { class: "mb-3 row" }
const _hoisted_12 = {
  id: "navbarItems",
  class: "page-selection-container"
}
const _hoisted_13 = ["for"]
const _hoisted_14 = ["checked", "id", "onChange"]
const _hoisted_15 = { class: "mb-3 row" }
const _hoisted_16 = { class: "col-sm-10" }
const _hoisted_17 = { class: "mb-3 row" }
const _hoisted_18 = { class: "col-sm-10" }
const _hoisted_19 = { class: "mb-3 row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[12] || (_cache[12] = _createElementVNode("label", {
        for: "inputLanguage",
        class: "col-sm-2 col-form-label"
      }, " Language ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          onChange: _cache[0] || (_cache[0] = () => $setup.setLanguage(_ctx.selectedLanguage)),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
          class: "form-select",
          "aria-label": "Select a Language",
          id: "inputLanguage"
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("option", { value: "en-gb" }, "British English", -1),
          _createElementVNode("option", { value: "en-us" }, "US English", -1)
        ]))], 544), [
          [_vModelSelect, _ctx.selectedLanguage]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[13] || (_cache[13] = _createElementVNode("label", {
        for: "inputTimezone",
        class: "col-sm-2 col-form-label"
      }, " Timezone ", -1)),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          onChange: _cache[2] || (_cache[2] = () => $setup.setTimeZone(_ctx.selectedTimezone)),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTimezone) = $event)),
          class: "form-select",
          "aria-label": "Select a Timezone",
          id: "inputTimezone"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timezones, (zone) => {
            return (_openBlock(), _createElementBlock("option", {
              value: zone,
              key: zone
            }, _toDisplayString(zone), 9, _hoisted_5))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.selectedTimezone]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[15] || (_cache[15] = _createElementVNode("label", {
        for: "inputTheme",
        class: "col-sm-2 col-form-label"
      }, " Theme ", -1)),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("select", {
          onChange: _cache[4] || (_cache[4] = () => $setup.setTheme(_ctx.selectedTheme)),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTheme) = $event)),
          class: "form-select",
          "aria-label": "Select a Theme",
          id: "inputTheme"
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("option", { value: "light" }, "Light", -1)
        ]))], 544), [
          [_vModelSelect, _ctx.selectedTheme]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[16] || (_cache[16] = _createElementVNode("label", {
        for: "currentTime",
        class: "col-sm-2 col-form-label"
      }, " Current Time ", -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.currentTime), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[17] || (_cache[17] = _createElementVNode("label", {
        for: "navbarItems",
        class: "col-sm-2 col-form-label"
      }, " Navbar Items ", -1)),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPages, (page) => {
          return (_openBlock(), _createElementBlock("div", {
            key: page.name,
            class: "label-input-group"
          }, [
            _createElementVNode("label", {
              for: `pageCheckbox${page.name}`,
              class: "col-sm-2 col-form-label"
            }, _toDisplayString(page.name), 9, _hoisted_13),
            _createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              checked: page.enabled,
              id: `pageCheckbox${page.name}`,
              onChange: ($event: any) => ($setup.updateSelectedPages(page.name, !page.enabled))
            }, null, 40, _hoisted_14)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _cache[18] || (_cache[18] = _createElementVNode("label", {
        for: "editNavbarCheckbox",
        class: "col-sm-2 col-form-label"
      }, " Edit Navbar Layout ", -1)),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editNavBar) = $event)),
          onChange: _cache[7] || (_cache[7] = () => $setup.setEditNavBar(_ctx.editNavBar)),
          id: "editNavbarCheckbox"
        }, null, 544), [
          [_vModelCheckbox, _ctx.editNavBar]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _cache[19] || (_cache[19] = _createElementVNode("label", {
        for: "maxBurstsSelectableInput",
        class: "col-sm-2 col-form-label"
      }, " Max Bursts Selectable ", -1)),
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createElementVNode("input", {
          class: "form-number-input",
          type: "number",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.maxBurstsSelectable) = $event)),
          onChange: _cache[9] || (_cache[9] = () => $setup.setMaxBurstsSelectable(_ctx.maxBurstsSelectable)),
          id: "maxBurstsSelectableInput"
        }, null, 544), [
          [_vModelText, _ctx.maxBurstsSelectable]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        class: "offset-sm-2 col-sm-2 btn btn-outline-danger",
        title: "Log out",
        onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.logout()))
      }, "Log out")
    ])
  ], 64))
}